export const countryOptions = [
  { label: "Afghanistan", value: "AF", flag: "AF" },
  { label: "land Islands", value: "AX", flag: "AX" },
  { label: "Albania", value: "AL", flag: "it" },
  { label: "Algeria", value: "DZ" },
  { label: "American Samoa", value: "AS" },
  { label: "AndorrA", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Anguilla", value: "AI" },
  { label: "Antarctica", value: "AQ" },
  { label: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Aruba", value: "AW" },
  { label: "Australia", value: "AU" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "Bahamas", value: "BS" },
  { label: "Bahrain", value: "BH" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bermuda", value: "BM" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia", value: "BO" },
  { label: "Bosnia and Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Bouvet Island", value: "BV" },
  { label: "Brazil", value: "BR" },
  { label: "British Indian Ocean Territory", value: "IO" },
  { label: "Brunei Darussalam", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Cape Verde", value: "CV" },
  { label: "Cayman Islands", value: "KY" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Christmas Island", value: "CX" },
  { label: "Cocos (Keeling) Islands", value: "CC" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo", value: "CG" },
  { label: "Congo, The Democratic Republic of the", value: "CD" },
  { label: "Cook Islands", value: "CK" },
  { label: "Costa Rica", value: "CR" },
  { label: "Cote D'Ivoire", value: "CI" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Cyprus", value: "CY" },
  { label: "Czech Republic", value: "CZ" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Ethiopia", value: "ET" },
  { label: "Falkland Islands (Malvinas)", value: "FK" },
  { label: "Faroe Islands", value: "FO" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "French Guiana", value: "GF" },
  { label: "French Polynesia", value: "PF" },
  { label: "French Southern Territories", value: "TF" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Gibraltar", value: "GI" },
  { label: "Greece", value: "GR" },
  { label: "Greenland", value: "GL" },
  { label: "Grenada", value: "GD" },
  { label: "Guadeloupe", value: "GP" },
  { label: "Guam", value: "GU" },
  { label: "Guatemala", value: "GT" },
  { label: "Guernsey", value: "GG" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Heard Island and Mcdonald Islands", value: "HM" },
  { label: "Holy See (Vatican City State)", value: "VA" },
  { label: "Honduras", value: "HN" },
  { label: "Hong Kong", value: "HK" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran, Islamic Republic Of", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Isle of Man", value: "IM" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jersey", value: "JE" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Korea, Democratic People'S Republic of", value: "KP" },
  { label: "Korea, Republic of", value: "KR" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Lao People'S Democratic Republic", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libyan Arab Jamahiriya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Macao", value: "MO" },
  { label: "Macedonia, The Former Yugoslav Republic of", value: "MK" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Martinique", value: "MQ" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mayotte", value: "YT" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia, Federated States of", value: "FM" },
  { label: "Moldova, Republic of", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montenegro", value: "ME" },
  { label: "Montserrat", value: "MS" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar", value: "MM" },
  { label: "Namibia", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "Netherlands Antilles", value: "AN" },
  { label: "New Caledonia", value: "NC" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "Niue", value: "NU" },
  { label: "Norfolk Island", value: "NF" },
  { label: "Northern Mariana Islands", value: "MP" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Palestinian Territory, Occupied", value: "PS" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Pitcairn", value: "PN" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Qatar", value: "QA" },
  { label: "Reunion", value: "RE" },
  { label: "Romania", value: "RO" },
  { label: "Russian Federation", value: "RU" },
  { label: "RWANDA", value: "RW" },
  { label: "Saint Helena", value: "SH" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Pierre and Miquelon", value: "PM" },
  { label: "Saint Vincent and the Grenadines", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome and Principe", value: "ST" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia", value: "RS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Georgia and the South Sandwich Islands", value: "GS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Surilabel", value: "SR" },
  { label: "Svalbard and Jan Mayen", value: "SJ" },
  { label: "Swaziland", value: "SZ" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "CH" },
  { label: "Syrian Arab Republic", value: "SY" },
  { label: "Taiwan, Province of China", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania, United Republic of", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Timor-Leste", value: "TL" },
  { label: "Togo", value: "TG" },
  { label: "Tokelau", value: "TK" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Turks and Caicos Islands", value: "TC" },
  { label: "Tuvalu", value: "TV" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  { label: "United States Minor Outlying Islands", value: "UM" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  { label: "Venezuela", value: "VE" },
  { label: "Viet Nam", value: "VN" },
  { label: "Virgin Islands, British", value: "VG" },
  { label: "Virgin Islands, U.S.", value: "VI" },
  { label: "Wallis and Futuna", value: "WF" },
  { label: "Western Sahara", value: "EH" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
];

export const lan2 = [
  { label: "English (US)", value: "en", flag: "us" },
  { label: "English (UK)", value: "en-uk", flag: "gb" },
  { label: "Chinese", value: "zh", flag: "cn" },
  { label: "Czech", value: "cs", flag: "cz" },
  { label: "Danish", value: "da", flag: "dk" },
  { label: "Dutch", value: "nl", flag: "nl" },
  { label: "Estonian", value: "et", flag: "ee" },
  { label: "Filipino", value: "fil", flag: "ph" },
  { label: "French", value: "fr", flag: "fr" },
  { label: "German", value: "de", flag: "de" },
  { label: "Greek", value: "el", flag: "gr" },
  { label: "Hindi", value: "hi", flag: "in" },
  { label: "Italian", value: "it", flag: "it" },
  { label: "Japanese", value: "ja", flag: "jp" },
  { label: "Korean", value: "ko", flag: "kr" },
  { label: "Malay", value: "ms", flag: "my" },
  { label: "Portuguese", value: "pt", flag: "pt" },
  { label: "Portuguese (Brazil)", value: "pt-br", flag: "br" },
  { label: "Romanian", value: "ro", flag: "ro" },
  { label: "Russian", value: "ru", flag: "ru" },
  { label: "Sinhala", value: "si", flag: "lk" },
  { label: "Slovak", value: "sk", flag: "sk" },
  { label: "Spanish", value: "es", flag: "es" },
  { label: "Swedish", value: "sv", flag: "se" },
];

export const language = [
  { label: "English (US)", value: "en" },
  { label: "English (UK)", value: "en-GB" },
  { label: "Chinese", value: "zh" },
  { label: "Czech", value: "cs" },
  { label: "Danish", value: "da" },
  { label: "Dutch", value: "nl" },
  { label: "Estonian", value: "et" },
  { label: "Filipino", value: "tl" },
  { label: "French", value: "fr" },
  { label: "German", value: "de" },
  { label: "Greek", value: "el" },
  { label: "Hindi", value: "hi" },
  { label: "Italian", value: "it" },
  { label: "Japanese", value: "ja" },
  { label: "Korean", value: "ko" },
  { label: "Malay", value: "ms" },
  { label: "Portuguese", value: "pt" },
  { label: "Portuguese (Brazil)", value: "pt-BR" },
  { label: "Romanian", value: "ro" },
  { label: "Russian", value: "ru" },
  { label: "Sinhala", value: "si" },
  { label: "Slovak", value: "sk" },
  { label: "Spanish", value: "es" },
  { label: "Swedish", value: "sv" },
];

export const currency = [
  { value: "all_currencies", label: "All Currencies" },
  {
    value: "AD",
    label: "Andorra - EUR",
    population: "84000",
    capital: "Andorra la Vella",
    continentName: "Europe",
  },
  {
    value: "AE",
    label: "United Arab Emirates - AED",
    population: "4975593",
    capital: "Abu Dhabi",
    continentName: "Asia",
  },
  {
    value: "AF",
    label: "Afghanistan - AFN",
    population: "29121286",
    capital: "Kabul",
    continentName: "Asia",
  },
  {
    value: "AG",
    label: "Antigua and Barbuda - XCD",
    population: "86754",
    capital: "St. John's",
    continentName: "North America",
  },
  {
    value: "AI",
    label: "Anguilla - XCD",
    population: "13254",
    capital: "The Valley",
    continentName: "North America",
  },
  {
    value: "AL",
    label: "Albania - ALL",
    population: "2986952",
    capital: "Tirana",
    continentName: "Europe",
  },
  {
    value: "AM",
    label: "Armenia - AMD",
    population: "2968000",
    capital: "Yerevan",
    continentName: "Asia",
  },
  {
    value: "AO",
    label: "Angola - AOA",
    population: "13068161",
    capital: "Luanda",
    continentName: "Africa",
  },
  {
    value: "AQ",
    label: "Antarctica - ",
    population: "0",
    capital: "",
    continentName: "Antarctica",
  },
  {
    value: "AR",
    label: "Argentina - ARS",
    population: "41343201",
    capital: "Buenos Aires",
    continentName: "South America",
  },
  {
    value: "AS",
    label: "American Samoa - USD",
    population: "57881",
    capital: "Pago Pago",
    continentName: "Oceania",
  },
  {
    value: "AT",
    label: "Austria - EUR",
    population: "8205000",
    capital: "Vienna",
    continentName: "Europe",
  },
  {
    value: "AU",
    label: "Australia - AUD",
    population: "21515754",
    capital: "Canberra",
    continentName: "Oceania",
  },
  {
    value: "AW",
    label: "Aruba - AWG",
    population: "71566",
    capital: "Oranjestad",
    continentName: "North America",
  },
  {
    value: "AX",
    label: "Åland - EUR",
    population: "26711",
    capital: "Mariehamn",
    continentName: "Europe",
  },
  {
    value: "AZ",
    label: "Azerbaijan - AZN",
    population: "8303512",
    capital: "Baku",
    continentName: "Asia",
  },
  {
    value: "BA",
    label: "Bosnia and Herzegovina - BAM",
    population: "4590000",
    capital: "Sarajevo",
    continentName: "Europe",
  },
  {
    value: "BB",
    label: "Barbados - BBD",
    population: "285653",
    capital: "Bridgetown",
    continentName: "North America",
  },
  {
    value: "BD",
    label: "Bangladesh - BDT",
    population: "156118464",
    capital: "Dhaka",
    continentName: "Asia",
  },
  {
    value: "BE",
    label: "Belgium - EUR",
    population: "10403000",
    capital: "Brussels",
    continentName: "Europe",
  },
  {
    value: "BF",
    label: "Burkina Faso - XOF",
    population: "16241811",
    capital: "Ouagadougou",
    continentName: "Africa",
  },
  {
    value: "BG",
    label: "Bulgaria - BGN",
    population: "7148785",
    capital: "Sofia",
    continentName: "Europe",
  },
  {
    value: "BH",
    label: "Bahrain - BHD",
    population: "738004",
    capital: "Manama",
    continentName: "Asia",
  },
  {
    value: "BI",
    label: "Burundi - BIF",
    population: "9863117",
    capital: "Bujumbura",
    continentName: "Africa",
  },
  {
    value: "BJ",
    label: "Benin - XOF",
    population: "9056010",
    capital: "Porto-Novo",
    continentName: "Africa",
  },
  {
    value: "BL",
    label: "Saint Barthélemy - EUR",
    population: "8450",
    capital: "Gustavia",
    continentName: "North America",
  },
  {
    value: "BM",
    label: "Bermuda - BMD",
    population: "65365",
    capital: "Hamilton",
    continentName: "North America",
  },
  {
    value: "BN",
    label: "Brunei - BND",
    population: "395027",
    capital: "Bandar Seri Begawan",
    continentName: "Asia",
  },
  {
    value: "BO",
    label: "Bolivia - BOB",
    population: "9947418",
    capital: "Sucre",
    continentName: "South America",
  },
  {
    value: "BQ",
    label: "Bonaire - USD",
    population: "18012",
    capital: "Kralendijk",
    continentName: "North America",
  },
  {
    value: "BR",
    label: "Brazil - BRL",
    population: "201103330",
    capital: "Brasília",
    continentName: "South America",
  },
  {
    value: "BS",
    label: "Bahamas - BSD",
    population: "301790",
    capital: "Nassau",
    continentName: "North America",
  },
  {
    value: "BT",
    label: "Bhutan - BTN",
    population: "699847",
    capital: "Thimphu",
    continentName: "Asia",
  },
  {
    value: "BV",
    label: "Bouvet Island - NOK",
    population: "0",
    capital: "",
    continentName: "Antarctica",
  },
  {
    value: "BW",
    label: "Botswana - BWP",
    population: "2029307",
    capital: "Gaborone",
    continentName: "Africa",
  },
  {
    value: "BY",
    label: "Belarus - BYR",
    population: "9685000",
    capital: "Minsk",
    continentName: "Europe",
  },
  {
    value: "BZ",
    label: "Belize - BZD",
    population: "314522",
    capital: "Belmopan",
    continentName: "North America",
  },
  {
    value: "CA",
    label: "Canada - CAD",
    population: "33679000",
    capital: "Ottawa",
    continentName: "North America",
  },
  {
    value: "CC",
    label: "Cocos [Keeling] Islands - AUD",
    population: "628",
    capital: "West Island",
    continentName: "Asia",
  },
  {
    value: "CD",
    label: "Democratic Republic of the Congo - CDF",
    population: "70916439",
    capital: "Kinshasa",
    continentName: "Africa",
  },
  {
    value: "CF",
    label: "Central African Republic - XAF",
    population: "4844927",
    capital: "Bangui",
    continentName: "Africa",
  },
  {
    value: "CG",
    label: "Republic of the Congo - XAF",
    population: "3039126",
    capital: "Brazzaville",
    continentName: "Africa",
  },
  {
    value: "CH",
    label: "Switzerland - CHF",
    population: "7581000",
    capital: "Bern",
    continentName: "Europe",
  },
  {
    value: "CI",
    label: "Ivory Coast - XOF",
    population: "21058798",
    capital: "Yamoussoukro",
    continentName: "Africa",
  },
  {
    value: "CK",
    label: "Cook Islands - NZD",
    population: "21388",
    capital: "Avarua",
    continentName: "Oceania",
  },
  {
    value: "CL",
    label: "Chile - CLP",
    population: "16746491",
    capital: "Santiago",
    continentName: "South America",
  },
  {
    value: "CM",
    label: "Cameroon - XAF",
    population: "19294149",
    capital: "Yaoundé",
    continentName: "Africa",
  },
  {
    value: "CN",
    label: "China - CNY",
    population: "1330044000",
    capital: "Beijing",
    continentName: "Asia",
  },
  {
    value: "CO",
    label: "Colombia - COP",
    population: "47790000",
    capital: "Bogotá",
    continentName: "South America",
  },
  {
    value: "CR",
    label: "Costa Rica - CRC",
    population: "4516220",
    capital: "San José",
    continentName: "North America",
  },
  {
    value: "CU",
    label: "Cuba - CUP",
    population: "11423000",
    capital: "Havana",
    continentName: "North America",
  },
  {
    value: "CV",
    label: "Cape Verde - CVE",
    population: "508659",
    capital: "Praia",
    continentName: "Africa",
  },
  {
    value: "CW",
    label: "Curacao - ANG",
    population: "141766",
    capital: "Willemstad",
    continentName: "North America",
  },
  {
    value: "CX",
    label: "Christmas Island - AUD",
    population: "1500",
    capital: "Flying Fish Cove",
    continentName: "Asia",
  },
  {
    value: "CY",
    label: "Cyprus - EUR",
    population: "1102677",
    capital: "Nicosia",
    continentName: "Europe",
  },
  {
    value: "CZ",
    label: "Czechia - CZK",
    population: "10476000",
    capital: "Prague",
    continentName: "Europe",
  },
  {
    value: "DE",
    label: "Germany - EUR",
    population: "81802257",
    capital: "Berlin",
    continentName: "Europe",
  },
  {
    value: "DJ",
    label: "Djibouti - DJF",
    population: "740528",
    capital: "Djibouti",
    continentName: "Africa",
  },
  {
    value: "DK",
    label: "Denmark - DKK",
    population: "5484000",
    capital: "Copenhagen",
    continentName: "Europe",
  },
  {
    value: "DM",
    label: "Dominica - XCD",
    population: "72813",
    capital: "Roseau",
    continentName: "North America",
  },
  {
    value: "DO",
    label: "Dominican Republic - DOP",
    population: "9823821",
    capital: "Santo Domingo",
    continentName: "North America",
  },
  {
    value: "DZ",
    label: "Algeria - DZD",
    population: "34586184",
    capital: "Algiers",
    continentName: "Africa",
  },
  {
    value: "EC",
    label: "Ecuador - USD",
    population: "14790608",
    capital: "Quito",
    continentName: "South America",
  },
  {
    value: "EE",
    label: "Estonia - EUR",
    population: "1291170",
    capital: "Tallinn",
    continentName: "Europe",
  },
  {
    value: "EG",
    label: "Egypt - EGP",
    population: "80471869",
    capital: "Cairo",
    continentName: "Africa",
  },
  {
    value: "EH",
    label: "Western Sahara - MAD",
    population: "273008",
    capital: "Laâyoune / El Aaiún",
    continentName: "Africa",
  },
  {
    value: "ER",
    label: "Eritrea - ERN",
    population: "5792984",
    capital: "Asmara",
    continentName: "Africa",
  },
  {
    value: "ES",
    label: "Spain - EUR",
    population: "46505963",
    capital: "Madrid",
    continentName: "Europe",
  },
  {
    value: "ET",
    label: "Ethiopia - ETB",
    population: "88013491",
    capital: "Addis Ababa",
    continentName: "Africa",
  },
  {
    value: "FI",
    label: "Finland - EUR",
    population: "5244000",
    capital: "Helsinki",
    continentName: "Europe",
  },
  {
    value: "FJ",
    label: "Fiji - FJD",
    population: "875983",
    capital: "Suva",
    continentName: "Oceania",
  },
  {
    value: "FK",
    label: "Falkland Islands - FKP",
    population: "2638",
    capital: "Stanley",
    continentName: "South America",
  },
  {
    value: "FM",
    label: "Micronesia - USD",
    population: "107708",
    capital: "Palikir",
    continentName: "Oceania",
  },
  {
    value: "FO",
    label: "Faroe Islands - DKK",
    population: "48228",
    capital: "Tórshavn",
    continentName: "Europe",
  },
  {
    value: "FR",
    label: "France - EUR",
    population: "64768389",
    capital: "Paris",
    continentName: "Europe",
  },
  {
    value: "GA",
    label: "Gabon - XAF",
    population: "1545255",
    capital: "Libreville",
    continentName: "Africa",
  },
  {
    value: "GB",
    label: "United Kingdom - GBP",
    population: "62348447",
    capital: "London",
    continentName: "Europe",
  },
  {
    value: "GD",
    label: "Grenada - XCD",
    population: "107818",
    capital: "St. George's",
    continentName: "North America",
  },
  {
    value: "GE",
    label: "Georgia - GEL",
    population: "4630000",
    capital: "Tbilisi",
    continentName: "Asia",
  },
  {
    value: "GF",
    label: "French Guiana - EUR",
    population: "195506",
    capital: "Cayenne",
    continentName: "South America",
  },
  {
    value: "GG",
    label: "Guernsey - GBP",
    population: "65228",
    capital: "St Peter Port",
    continentName: "Europe",
  },
  {
    value: "GH",
    label: "Ghana - GHS",
    population: "24339838",
    capital: "Accra",
    continentName: "Africa",
  },
  {
    value: "GI",
    label: "Gibraltar - GIP",
    population: "27884",
    capital: "Gibraltar",
    continentName: "Europe",
  },
  {
    value: "GL",
    label: "Greenland - DKK",
    population: "56375",
    capital: "Nuuk",
    continentName: "North America",
  },
  {
    value: "GM",
    label: "Gambia - GMD",
    population: "1593256",
    capital: "Bathurst",
    continentName: "Africa",
  },
  {
    value: "GN",
    label: "Guinea - GNF",
    population: "10324025",
    capital: "Conakry",
    continentName: "Africa",
  },
  {
    value: "GP",
    label: "Guadeloupe - EUR",
    population: "443000",
    capital: "Basse-Terre",
    continentName: "North America",
  },
  {
    value: "GQ",
    label: "Equatorial Guinea - XAF",
    population: "1014999",
    capital: "Malabo",
    continentName: "Africa",
  },
  {
    value: "GR",
    label: "Greece - EUR",
    population: "11000000",
    capital: "Athens",
    continentName: "Europe",
  },
  {
    value: "GS",
    label: "South Georgia and the South Sandwich Islands - GBP",
    population: "30",
    capital: "Grytviken",
    continentName: "Antarctica",
  },
  {
    value: "GT",
    label: "Guatemala - GTQ",
    population: "13550440",
    capital: "Guatemala City",
    continentName: "North America",
  },
  {
    value: "GU",
    label: "Guam - USD",
    population: "159358",
    capital: "Hagåtña",
    continentName: "Oceania",
  },
  {
    value: "GW",
    label: "Guinea-Bissau - XOF",
    population: "1565126",
    capital: "Bissau",
    continentName: "Africa",
  },
  {
    value: "GY",
    label: "Guyana - GYD",
    population: "748486",
    capital: "Georgetown",
    continentName: "South America",
  },
  {
    value: "HK",
    label: "Hong Kong - HKD",
    population: "6898686",
    capital: "Hong Kong",
    continentName: "Asia",
  },
  {
    value: "HM",
    label: "Heard Island and McDonald Islands - AUD",
    population: "0",
    capital: "",
    continentName: "Antarctica",
  },
  {
    value: "HN",
    label: "Honduras - HNL",
    population: "7989415",
    capital: "Tegucigalpa",
    continentName: "North America",
  },
  {
    value: "HR",
    label: "Croatia - HRK",
    population: "4284889",
    capital: "Zagreb",
    continentName: "Europe",
  },
  {
    value: "HT",
    label: "Haiti - HTG",
    population: "9648924",
    capital: "Port-au-Prince",
    continentName: "North America",
  },
  {
    value: "HU",
    label: "Hungary - HUF",
    population: "9982000",
    capital: "Budapest",
    continentName: "Europe",
  },
  {
    value: "ID",
    label: "Indonesia - IDR",
    population: "242968342",
    capital: "Jakarta",
    continentName: "Asia",
  },
  {
    value: "IE",
    label: "Ireland - EUR",
    population: "4622917",
    capital: "Dublin",
    continentName: "Europe",
  },
  {
    value: "IL",
    label: "Israel - ILS",
    population: "7353985",
    capital: "",
    continentName: "Asia",
  },
  {
    value: "IM",
    label: "Isle of Man - GBP",
    population: "75049",
    capital: "Douglas",
    continentName: "Europe",
  },
  {
    value: "IN",
    label: "India - INR",
    population: "1173108018",
    capital: "New Delhi",
    continentName: "Asia",
  },
  {
    value: "IO",
    label: "British Indian Ocean Territory - USD",
    population: "4000",
    capital: "",
    continentName: "Asia",
  },
  {
    value: "IQ",
    label: "Iraq - IQD",
    population: "29671605",
    capital: "Baghdad",
    continentName: "Asia",
  },
  {
    value: "IR",
    label: "Iran - IRR",
    population: "76923300",
    capital: "Tehran",
    continentName: "Asia",
  },
  {
    value: "IS",
    label: "Iceland - ISK",
    population: "308910",
    capital: "Reykjavik",
    continentName: "Europe",
  },
  {
    value: "IT",
    label: "Italy - EUR",
    population: "60340328",
    capital: "Rome",
    continentName: "Europe",
  },
  {
    value: "JE",
    label: "Jersey - GBP",
    population: "90812",
    capital: "Saint Helier",
    continentName: "Europe",
  },
  {
    value: "JM",
    label: "Jamaica - JMD",
    population: "2847232",
    capital: "Kingston",
    continentName: "North America",
  },
  {
    value: "JO",
    label: "Jordan - JOD",
    population: "6407085",
    capital: "Amman",
    continentName: "Asia",
  },
  {
    value: "JP",
    label: "Japan - JPY",
    population: "127288000",
    capital: "Tokyo",
    continentName: "Asia",
  },
  {
    value: "KE",
    label: "Kenya - KES",
    population: "40046566",
    capital: "Nairobi",
    continentName: "Africa",
  },
  {
    value: "KG",
    label: "Kyrgyzstan - KGS",
    population: "5776500",
    capital: "Bishkek",
    continentName: "Asia",
  },
  {
    value: "KH",
    label: "Cambodia - KHR",
    population: "14453680",
    capital: "Phnom Penh",
    continentName: "Asia",
  },
  {
    value: "KI",
    label: "Kiribati - AUD",
    population: "92533",
    capital: "Tarawa",
    continentName: "Oceania",
  },
  {
    value: "KM",
    label: "Comoros - KMF",
    population: "773407",
    capital: "Moroni",
    continentName: "Africa",
  },
  {
    value: "KN",
    label: "Saint Kitts and Nevis - XCD",
    population: "51134",
    capital: "Basseterre",
    continentName: "North America",
  },
  {
    value: "KP",
    label: "North Korea - KPW",
    population: "22912177",
    capital: "Pyongyang",
    continentName: "Asia",
  },
  {
    value: "KR",
    label: "South Korea - KRW",
    population: "48422644",
    capital: "Seoul",
    continentName: "Asia",
  },
  {
    value: "KW",
    label: "Kuwait - KWD",
    population: "2789132",
    capital: "Kuwait City",
    continentName: "Asia",
  },
  {
    value: "KY",
    label: "Cayman Islands - KYD",
    population: "44270",
    capital: "George Town",
    continentName: "North America",
  },
  {
    value: "KZ",
    label: "Kazakhstan - KZT",
    population: "15340000",
    capital: "Astana",
    continentName: "Asia",
  },
  {
    value: "LA",
    label: "Laos - LAK",
    population: "6368162",
    capital: "Vientiane",
    continentName: "Asia",
  },
  {
    value: "LB",
    label: "Lebanon - LBP",
    population: "4125247",
    capital: "Beirut",
    continentName: "Asia",
  },
  {
    value: "LC",
    label: "Saint Lucia - XCD",
    population: "160922",
    capital: "Castries",
    continentName: "North America",
  },
  {
    value: "LI",
    label: "Liechtenstein - CHF",
    population: "35000",
    capital: "Vaduz",
    continentName: "Europe",
  },
  {
    value: "LK",
    label: "Sri Lanka - LKR",
    population: "21513990",
    capital: "Colombo",
    continentName: "Asia",
  },
  {
    value: "LR",
    label: "Liberia - LRD",
    population: "3685076",
    capital: "Monrovia",
    continentName: "Africa",
  },
  {
    value: "LS",
    label: "Lesotho - LSL",
    population: "1919552",
    capital: "Maseru",
    continentName: "Africa",
  },
  {
    value: "LT",
    label: "Lithuania - EUR",
    population: "2944459",
    capital: "Vilnius",
    continentName: "Europe",
  },
  {
    value: "LU",
    label: "Luxembourg - EUR",
    population: "497538",
    capital: "Luxembourg",
    continentName: "Europe",
  },
  {
    value: "LV",
    label: "Latvia - EUR",
    population: "2217969",
    capital: "Riga",
    continentName: "Europe",
  },
  {
    value: "LY",
    label: "Libya - LYD",
    population: "6461454",
    capital: "Tripoli",
    continentName: "Africa",
  },
  {
    value: "MA",
    label: "Morocco - MAD",
    population: "33848242",
    capital: "Rabat",
    continentName: "Africa",
  },
  {
    value: "MC",
    label: "Monaco - EUR",
    population: "32965",
    capital: "Monaco",
    continentName: "Europe",
  },
  {
    value: "MD",
    label: "Moldova - MDL",
    population: "4324000",
    capital: "Chişinău",
    continentName: "Europe",
  },
  {
    value: "ME",
    label: "Montenegro - EUR",
    population: "666730",
    capital: "Podgorica",
    continentName: "Europe",
  },
  {
    value: "MF",
    label: "Saint Martin - EUR",
    population: "35925",
    capital: "Marigot",
    continentName: "North America",
  },
  {
    value: "MG",
    label: "Madagascar - MGA",
    population: "21281844",
    capital: "Antananarivo",
    continentName: "Africa",
  },
  {
    value: "MH",
    label: "Marshall Islands - USD",
    population: "65859",
    capital: "Majuro",
    continentName: "Oceania",
  },
  {
    value: "MK",
    label: "Macedonia - MKD",
    population: "2062294",
    capital: "Skopje",
    continentName: "Europe",
  },
  {
    value: "ML",
    label: "Mali - XOF",
    population: "13796354",
    capital: "Bamako",
    continentName: "Africa",
  },
  {
    value: "MM",
    label: "Myanmar [Burma] - MMK",
    population: "53414374",
    capital: "Naypyitaw",
    continentName: "Asia",
  },
  {
    value: "MN",
    label: "Mongolia - MNT",
    population: "3086918",
    capital: "Ulan Bator",
    continentName: "Asia",
  },
  {
    value: "MO",
    label: "Macao - MOP",
    population: "449198",
    capital: "Macao",
    continentName: "Asia",
  },
  {
    value: "MP",
    label: "Northern Mariana Islands - USD",
    population: "53883",
    capital: "Saipan",
    continentName: "Oceania",
  },
  {
    value: "MQ",
    label: "Martinique - EUR",
    population: "432900",
    capital: "Fort-de-France",
    continentName: "North America",
  },
  {
    value: "MR",
    label: "Mauritania - MRO",
    population: "3205060",
    capital: "Nouakchott",
    continentName: "Africa",
  },
  {
    value: "MS",
    label: "Montserrat - XCD",
    population: "9341",
    capital: "Plymouth",
    continentName: "North America",
  },
  {
    value: "MT",
    label: "Malta - EUR",
    population: "403000",
    capital: "Valletta",
    continentName: "Europe",
  },
  {
    value: "MU",
    label: "Mauritius - MUR",
    population: "1294104",
    capital: "Port Louis",
    continentName: "Africa",
  },
  {
    value: "MV",
    label: "Maldives - MVR",
    population: "395650",
    capital: "Malé",
    continentName: "Asia",
  },
  {
    value: "MW",
    label: "Malawi - MWK",
    population: "15447500",
    capital: "Lilongwe",
    continentName: "Africa",
  },
  {
    value: "MX",
    label: "Mexico - MXN",
    population: "112468855",
    capital: "Mexico City",
    continentName: "North America",
  },
  {
    value: "MY",
    label: "Malaysia - MYR",
    population: "28274729",
    capital: "Kuala Lumpur",
    continentName: "Asia",
  },
  {
    value: "MZ",
    label: "Mozambique - MZN",
    population: "22061451",
    capital: "Maputo",
    continentName: "Africa",
  },
  {
    value: "NA",
    label: "Namibia - NAD",
    population: "2128471",
    capital: "Windhoek",
    continentName: "Africa",
  },
  {
    value: "NC",
    label: "New Caledonia - XPF",
    population: "216494",
    capital: "Noumea",
    continentName: "Oceania",
  },
  {
    value: "NE",
    label: "Niger - XOF",
    population: "15878271",
    capital: "Niamey",
    continentName: "Africa",
  },
  {
    value: "NF",
    label: "Norfolk Island - AUD",
    population: "1828",
    capital: "Kingston",
    continentName: "Oceania",
  },
  {
    value: "NG",
    label: "Nigeria - NGN",
    population: "154000000",
    capital: "Abuja",
    continentName: "Africa",
  },
  {
    value: "NI",
    label: "Nicaragua - NIO",
    population: "5995928",
    capital: "Managua",
    continentName: "North America",
  },
  {
    value: "NL",
    label: "Netherlands - EUR",
    population: "16645000",
    capital: "Amsterdam",
    continentName: "Europe",
  },
  {
    value: "NO",
    label: "Norway - NOK",
    population: "5009150",
    capital: "Oslo",
    continentName: "Europe",
  },
  {
    value: "NP",
    label: "Nepal - NPR",
    population: "28951852",
    capital: "Kathmandu",
    continentName: "Asia",
  },
  {
    value: "NR",
    label: "Nauru - AUD",
    population: "10065",
    capital: "Yaren",
    continentName: "Oceania",
  },
  {
    value: "NU",
    label: "Niue - NZD",
    population: "2166",
    capital: "Alofi",
    continentName: "Oceania",
  },
  {
    value: "NZ",
    label: "New Zealand - NZD",
    population: "4252277",
    capital: "Wellington",
    continentName: "Oceania",
  },
  {
    value: "OM",
    label: "Oman - OMR",
    population: "2967717",
    capital: "Muscat",
    continentName: "Asia",
  },
  {
    value: "PA",
    label: "Panama - PAB",
    population: "3410676",
    capital: "Panama City",
    continentName: "North America",
  },
  {
    value: "PE",
    label: "Peru - PEN",
    population: "29907003",
    capital: "Lima",
    continentName: "South America",
  },
  {
    value: "PF",
    label: "French Polynesia - XPF",
    population: "270485",
    capital: "Papeete",
    continentName: "Oceania",
  },
  {
    value: "PG",
    label: "Papua New Guinea - PGK",
    population: "6064515",
    capital: "Port Moresby",
    continentName: "Oceania",
  },
  {
    value: "PH",
    label: "Philippines - PHP",
    population: "99900177",
    capital: "Manila",
    continentName: "Asia",
  },
  {
    value: "PK",
    label: "Pakistan - PKR",
    population: "184404791",
    capital: "Islamabad",
    continentName: "Asia",
  },
  {
    value: "PL",
    label: "Poland - PLN",
    population: "38500000",
    capital: "Warsaw",
    continentName: "Europe",
  },
  {
    value: "PM",
    label: "Saint Pierre and Miquelon - EUR",
    population: "7012",
    capital: "Saint-Pierre",
    continentName: "North America",
  },
  {
    value: "PN",
    label: "Pitcairn Islands - NZD",
    population: "46",
    capital: "Adamstown",
    continentName: "Oceania",
  },
  {
    value: "PR",
    label: "Puerto Rico - USD",
    population: "3916632",
    capital: "San Juan",
    continentName: "North America",
  },
  {
    value: "PS",
    label: "Palestine - ILS",
    population: "3800000",
    capital: "",
    continentName: "Asia",
  },
  {
    value: "PT",
    label: "Portugal - EUR",
    population: "10676000",
    capital: "Lisbon",
    continentName: "Europe",
  },
  {
    value: "PW",
    label: "Palau - USD",
    population: "19907",
    capital: "Melekeok",
    continentName: "Oceania",
  },
  {
    value: "PY",
    label: "Paraguay - PYG",
    population: "6375830",
    capital: "Asunción",
    continentName: "South America",
  },
  {
    value: "QA",
    label: "Qatar - QAR",
    population: "840926",
    capital: "Doha",
    continentName: "Asia",
  },
  {
    value: "RE",
    label: "Réunion - EUR",
    population: "776948",
    capital: "Saint-Denis",
    continentName: "Africa",
  },
  {
    value: "RO",
    label: "Romania - RON",
    population: "21959278",
    capital: "Bucharest",
    continentName: "Europe",
  },
  {
    value: "RS",
    label: "Serbia - RSD",
    population: "7344847",
    capital: "Belgrade",
    continentName: "Europe",
  },
  {
    value: "RU",
    label: "Russia - RUB",
    population: "140702000",
    capital: "Moscow",
    continentName: "Europe",
  },
  {
    value: "RW",
    label: "Rwanda - RWF",
    population: "11055976",
    capital: "Kigali",
    continentName: "Africa",
  },
  {
    value: "SA",
    label: "Saudi Arabia - SAR",
    population: "25731776",
    capital: "Riyadh",
    continentName: "Asia",
  },
  {
    value: "SB",
    label: "Solomon Islands - SBD",
    population: "559198",
    capital: "Honiara",
    continentName: "Oceania",
  },
  {
    value: "SC",
    label: "Seychelles - SCR",
    population: "88340",
    capital: "Victoria",
    continentName: "Africa",
  },
  {
    value: "SD",
    label: "Sudan - SDG",
    population: "35000000",
    capital: "Khartoum",
    continentName: "Africa",
  },
  {
    value: "SE",
    label: "Sweden - SEK",
    population: "9828655",
    capital: "Stockholm",
    continentName: "Europe",
  },
  {
    value: "SG",
    label: "Singapore - SGD",
    population: "4701069",
    capital: "Singapore",
    continentName: "Asia",
  },
  {
    value: "SH",
    label: "Saint Helena - SHP",
    population: "7460",
    capital: "Jamestown",
    continentName: "Africa",
  },
  {
    value: "SI",
    label: "Slovenia - EUR",
    population: "2007000",
    capital: "Ljubljana",
    continentName: "Europe",
  },
  {
    value: "SJ",
    label: "Svalbard and Jan Mayen - NOK",
    population: "2550",
    capital: "Longyearbyen",
    continentName: "Europe",
  },
  {
    value: "SK",
    label: "Slovakia - EUR",
    population: "5455000",
    capital: "Bratislava",
    continentName: "Europe",
  },
  {
    value: "SL",
    label: "Sierra Leone - SLL",
    population: "5245695",
    capital: "Freetown",
    continentName: "Africa",
  },
  {
    value: "SM",
    label: "San Marino - EUR",
    population: "31477",
    capital: "San Marino",
    continentName: "Europe",
  },
  {
    value: "SN",
    label: "Senegal - XOF",
    population: "12323252",
    capital: "Dakar",
    continentName: "Africa",
  },
  {
    value: "SO",
    label: "Somalia - SOS",
    population: "10112453",
    capital: "Mogadishu",
    continentName: "Africa",
  },
  {
    value: "SR",
    label: "Suriname - SRD",
    population: "492829",
    capital: "Paramaribo",
    continentName: "South America",
  },
  {
    value: "SS",
    label: "South Sudan - SSP",
    population: "8260490",
    capital: "Juba",
    continentName: "Africa",
  },
  {
    value: "ST",
    label: "São Tomé and Príncipe - STD",
    population: "175808",
    capital: "São Tomé",
    continentName: "Africa",
  },
  {
    value: "SV",
    label: "El Salvador - USD",
    population: "6052064",
    capital: "San Salvador",
    continentName: "North America",
  },
  {
    value: "SX",
    label: "Sint Maarten - ANG",
    population: "37429",
    capital: "Philipsburg",
    continentName: "North America",
  },
  {
    value: "SY",
    label: "Syria - SYP",
    population: "22198110",
    capital: "Damascus",
    continentName: "Asia",
  },
  {
    value: "SZ",
    label: "Swaziland - SZL",
    population: "1354051",
    capital: "Mbabane",
    continentName: "Africa",
  },
  {
    value: "TC",
    label: "Turks and Caicos Islands - USD",
    population: "20556",
    capital: "Cockburn Town",
    continentName: "North America",
  },
  {
    value: "TD",
    label: "Chad - XAF",
    population: "10543464",
    capital: "N'Djamena",
    continentName: "Africa",
  },
  {
    value: "TF",
    label: "French Southern Territories - EUR",
    population: "140",
    capital: "Port-aux-Français",
    continentName: "Antarctica",
  },
  {
    value: "TG",
    label: "Togo - XOF",
    population: "6587239",
    capital: "Lomé",
    continentName: "Africa",
  },
  {
    value: "TH",
    label: "Thailand - THB",
    population: "67089500",
    capital: "Bangkok",
    continentName: "Asia",
  },
  {
    value: "TJ",
    label: "Tajikistan - TJS",
    population: "7487489",
    capital: "Dushanbe",
    continentName: "Asia",
  },
  {
    value: "TK",
    label: "Tokelau - NZD",
    population: "1466",
    capital: "",
    continentName: "Oceania",
  },
  {
    value: "TL",
    label: "East Timor - USD",
    population: "1154625",
    capital: "Dili",
    continentName: "Oceania",
  },
  {
    value: "TM",
    label: "Turkmenistan - TMT",
    population: "4940916",
    capital: "Ashgabat",
    continentName: "Asia",
  },
  {
    value: "TN",
    label: "Tunisia - TND",
    population: "10589025",
    capital: "Tunis",
    continentName: "Africa",
  },
  {
    value: "TO",
    label: "Tonga - TOP",
    population: "122580",
    capital: "Nuku'alofa",
    continentName: "Oceania",
  },
  {
    value: "TR",
    label: "Turkey - TRY",
    population: "77804122",
    capital: "Ankara",
    continentName: "Asia",
  },
  {
    value: "TT",
    label: "Trinidad and Tobago - TTD",
    population: "1228691",
    capital: "Port of Spain",
    continentName: "North America",
  },
  {
    value: "TV",
    label: "Tuvalu - AUD",
    population: "10472",
    capital: "Funafuti",
    continentName: "Oceania",
  },
  {
    value: "TW",
    label: "Taiwan - TWD",
    population: "22894384",
    capital: "Taipei",
    continentName: "Asia",
  },
  {
    value: "TZ",
    label: "Tanzania - TZS",
    population: "41892895",
    capital: "Dodoma",
    continentName: "Africa",
  },
  {
    value: "UA",
    label: "Ukraine - UAH",
    population: "45415596",
    capital: "Kiev",
    continentName: "Europe",
  },
  {
    value: "UG",
    label: "Uganda - UGX",
    population: "33398682",
    capital: "Kampala",
    continentName: "Africa",
  },
  {
    value: "UM",
    label: "U.S. Minor Outlying Islands - USD",
    population: "0",
    capital: "",
    continentName: "Oceania",
  },
  {
    value: "US",
    label: "United States - USD",
    population: "310232863",
    capital: "Washington",
    continentName: "North America",
  },
  {
    value: "UY",
    label: "Uruguay - UYU",
    population: "3477000",
    capital: "Montevideo",
    continentName: "South America",
  },
  {
    value: "UZ",
    label: "Uzbekistan - UZS",
    population: "27865738",
    capital: "Tashkent",
    continentName: "Asia",
  },
  {
    value: "VA",
    label: "Vatican City - EUR",
    population: "921",
    capital: "Vatican City",
    continentName: "Europe",
  },
  {
    value: "VC",
    label: "Saint Vincent and the Grenadines - XCD",
    population: "104217",
    capital: "Kingstown",
    continentName: "North America",
  },
  {
    value: "VE",
    label: "Venezuela - VEF",
    population: "27223228",
    capital: "Caracas",
    continentName: "South America",
  },
  {
    value: "VG",
    label: "British Virgin Islands - USD",
    population: "21730",
    capital: "Road Town",
    continentName: "North America",
  },
  {
    value: "VI",
    label: "U.S. Virgin Islands - USD",
    population: "108708",
    capital: "Charlotte Amalie",
    continentName: "North America",
  },
  {
    value: "VN",
    label: "Vietnam - VND",
    population: "89571130",
    capital: "Hanoi",
    continentName: "Asia",
  },
  {
    value: "VU",
    label: "Vanuatu - VUV",
    population: "221552",
    capital: "Port Vila",
    continentName: "Oceania",
  },
  {
    value: "WF",
    label: "Wallis and Futuna - XPF",
    population: "16025",
    capital: "Mata-Utu",
    continentName: "Oceania",
  },
  {
    value: "WS",
    label: "Samoa - WST",
    population: "192001",
    capital: "Apia",
    continentName: "Oceania",
  },
  {
    value: "XK",
    label: "Kosovo - EUR",
    population: "1800000",
    capital: "Pristina",
    continentName: "Europe",
  },
  {
    value: "YE",
    label: "Yemen - YER",
    population: "23495361",
    capital: "Sanaa",
    continentName: "Asia",
  },
  {
    value: "YT",
    label: "Mayotte - EUR",
    population: "159042",
    capital: "Mamoudzou",
    continentName: "Africa",
  },
  {
    value: "ZA",
    label: "South Africa - ZAR",
    population: "49000000",
    capital: "Pretoria",
    continentName: "Africa",
  },
  {
    value: "ZM",
    label: "Zambia - ZMW",
    population: "13460305",
    capital: "Lusaka",
    continentName: "Africa",
  },
  {
    value: "ZW",
    label: "Zimbabwe - ZWL",
    population: "13061000",
    capital: "Harare",
    continentName: "Africa",
  },
];

export const UserTypes = [
  {
    value: "support",
    label: "CRM Support",
  },
  {
    value: "marketing",
    label: "CRM Marketing",
  },
];

export const Gender = [
  { label: "Agender", value: "agender" },
  { label: "Bigender", value: "bigender" },
  { label: "Female", value: "female" },
  { label: "Genderfluid", value: "genderfluid" },
  { label: "Genderqueer", value: "genderqueer" },
  { label: "Male", value: "male" },
  { label: "Non-bianry", value: "non-bianry" },
  { label: "Ploygender", value: "ploygender" },
];

export const answer_type = [
  { label: "Short Text", value: "text" },
  { label: "Date", value: "date" },
  { label: "Time", value: "time" },
  { label: "Phone", value: "phone" },
  { label: "Email", value: "email" },
  { label: "Number", value: "number" },
  { label: "File Upload", value: "file" },
  { label: "Long Text", value: "textarea" },
  { label: "Yes/No", value: "yes_no" },
  { label: "Radio", value: "radio" },
  { label: "Select", value: "select" },
  { label: "Choice", value: "checkbox" },
];

export const leadStatus = [
  { label: "New", value: "new" },
  { label: "In Progress", value: "in_progress" },
  // { label: "Pending Contact", value: "pending_contact" },
  // { label: "Contacted ", value: "contacted " },
  // { label: "No Response", value: "no_response" },
  // { label: "Estimate sent", value: "estimation_send" },
  // { label: "Invoice sent", value: "invoice_send" },
  // { label: "Shipping", value: "shipping" },
  // { label: "Installation", value: "installation" },
  { label: "Cancelled", value: "cancelled" },
  // { label: "New", value: "new" },
  // { label: "Proposal", value: "proposal" },
  // { label: "Pending", value: "pending" },
  // { label: "Confirmed", value: "confirmed" },
  // { label: "Rejected", value: "rejected" },
  // { label: "Invoice", value: "invoice" },
  // { label: "Sent", value: "sent" },
  // { label: "Paid", value: "paid" },
  // { label: "Void", value: "void" },
  // { label: "Shipping", value: "shipping" },
];

export const logStatus = [
  { label: "New", value: "new" },
  { label: "Pending", value: "pending" },
  { label: "Confirmed", value: "confirmed" },
  { label: "Rejected", value: "rejected" },
  { label: "Invoice", value: "invoice" },
  { label: "Closed", value: "closed" },
  { label: "Pending Contact", value: "pending_contact" },
  { label: "Contacted ", value: "contacted " },
  { label: "No Response", value: "no_response" },
  { label: "Estimate sent", value: "estimation_send" },
  { label: "Invoice sent", value: "invoice_send" },
  { label: "Shipping", value: "shipping" },
  { label: "Installation", value: "installation" },
  { label: "Proposal", value: "proposal" },
  { label: "Sent", value: "sent" },
  { label: "Paid", value: "paid" },
  { label: "Void", value: "void" },
  { label: "Shipping", value: "shipping" },
];

export const newCurrency = [
  { value: "usd", label: "United States Dollar - USD" },
  { value: "eur", label: "Euro - EUR" },
  { value: "gbp", label: "British Pound - GBP" },
  { value: "aud", label: "Australian Dollar - AUD" },
  { value: "cad", label: "Canadian Dollar - CAD" },
  { value: "chf", label: "Swiss Franc - CHF" },
  { value: "czk", label: "Czech Koruna - CZK" },
  { value: "dkk", label: "Danish Krone - DKK" },
  { value: "hkd", label: "Hong Kong Dollar - HKD" },
  { value: "huf", label: "Hungarian Forint - HUF" },
  { value: "ils", label: "Israeli New Sheqel - ILS" },
  { value: "jpy", label: "Japanese Yen - JPY" },
  { value: "mxn", label: "Mexican Peso - MXN" },
  { value: "nok", label: "Norwegian Krone - NOK" },
  { value: "nzd", label: "New Zealand Dollar - NZD" },
  { value: "pln", label: "Polish Złoty - PLN" },
  { value: "sek", label: "Swedish Krona - SEK" },
  { value: "sgd", label: "Singapore Dollar - SGD" },
  { value: "afn", label: "Afghan Afghani - AFN" },
  { value: "all", label: "Albanian Lek - ALL" },
  { value: "dzd", label: "Algerian Dinar - DZD" },
  { value: "aoa", label: "Angolan Kwanza - AOA" },
  { value: "ars", label: "Argentine Peso - ARS" },
  { value: "amd", label: "Armenian Dram - AMD" },
  { value: "awg", label: "Aruban Florin - AWG" },
  { value: "azn", label: "Azerbaijani Manat - AZN" },
  { value: "bsd", label: "Bahamian Dollar - BSD" },
  { value: "bhd", label: "Bahraini Dinar - BHD" },
  { value: "bdt", label: "Bangladeshi Taka - BDT" },
  { value: "bbd", label: "Barbadian Dollar - BBD" },
  { value: "byr", label: "Belarusian Ruble - BYR" },
  { value: "bzd", label: "Belize Dollar - BZD" },
  { value: "bmd", label: "Bermudian Dollar - BMD" },
  { value: "btn", label: "Bhutanese Ngultrum - BTN" },
  { value: "bob", label: "Bolivian Boliviano - BOB" },
  { value: "bam", label: "Bosnia and Herzegovina Convertible Mark - BAM" },
  { value: "bwp", label: "Botswana Pula - BWP" },
  { value: "brl", label: "Brazilian Real - BRL" },
  { value: "bnd", label: "Brunei Dollar - BND" },
  { value: "bgn", label: "Bulgarian Lev - BGN" },
  { value: "bif", label: "Burundian Franc - BIF" },
  { value: "khr", label: "Cambodian Riel - KHR" },
  { value: "cve", label: "Cape Verdean Escudo - CVE" },
  { value: "kyd", label: "Cayman Islands Dollar - KYD" },
  { value: "xaf", label: "Central African Cfa Franc - XAF" },
  { value: "xpf", label: "Cfp Franc - XPF" },
  { value: "clp", label: "Chilean Peso - CLP" },
  { value: "cny", label: "Chinese Renminbi Yuan - CNY" },
  { value: "cop", label: "Colombian Peso - COP" },
  { value: "kmf", label: "Comorian Franc - KMF" },
  { value: "cdf", label: "Congolese Franc - CDF" },
  { value: "crc", label: "Costa Rican Colón - CRC" },
  { value: "hrk", label: "Croatian Kuna - HRK" },
  { value: "cuc", label: "Cuban Convertible Peso - CUC" },
  { value: "cup", label: "Cuban Peso - CUP" },
  { value: "djf", label: "Djiboutian Franc - DJF" },
  { value: "dop", label: "Dominican Peso - DOP" },
  { value: "xcd", label: "East Caribbean Dollar - XCD" },
  { value: "egp", label: "Egyptian Pound - EGP" },
  { value: "ern", label: "Eritrean Nakfa - ERN" },
  { value: "eek", label: "Estonian Kroon - EEK" },
  { value: "etb", label: "Ethiopian Birr - ETB" },
  { value: "fkp", label: "Falkland Pound - FKP" },
  { value: "fjd", label: "Fijian Dollar - FJD" },
  { value: "gmd", label: "Gambian Dalasi - GMD" },
  { value: "gel", label: "Georgian Lari - GEL" },
  { value: "ghs", label: "Ghanaian Cedi - GHS" },
  { value: "gip", label: "Gibraltar Pound - GIP" },
  { value: "gtq", label: "Guatemalan Quetzal - GTQ" },
  { value: "gnf", label: "Guinean Franc - GNF" },
  { value: "gyd", label: "Guyanese Dollar - GYD" },
  { value: "htg", label: "Haitian Gourde - HTG" },
  { value: "hnl", label: "Honduran Lempira - HNL" },
  { value: "isk", label: "Icelandic Króna - ISK" },
  { value: "inr", label: "Indian Rupee - INR" },
  { value: "idr", label: "Indonesian Rupiah - IDR" },
  { value: "irr", label: "Iranian Rial - IRR" },
  { value: "iqd", label: "Iraqi Dinar - IQD" },
  { value: "jmd", label: "Jamaican Dollar - JMD" },
  { value: "jod", label: "Jordanian Dinar - JOD" },
  { value: "kzt", label: "Kazakhstani Tenge - KZT" },
  { value: "kes", label: "Kenyan Shilling - KES" },
  { value: "kwd", label: "Kuwaiti Dinar - KWD" },
  { value: "kgs", label: "Kyrgyzstani Som - KGS" },
  { value: "lak", label: "Lao Kip - LAK" },
  { value: "lvl", label: "Latvian Lats - LVL" },
  { value: "lbp", label: "Lebanese Pound - LBP" },
  { value: "lsl", label: "Lesotho Loti - LSL" },
  { value: "lrd", label: "Liberian Dollar - LRD" },
  { value: "zar", label: "South African Rand - ZAR" },
  { value: "myr", label: "Malaysian Ringgit - MYR" },
  { value: "ghc", label: "Ghanaian Cedi - GHS" },
  { value: "yen", label: "Japanese Yen - JPY" },
  { value: "lyd", label: "Libyan Dinar - LYD" },
  { value: "ltl", label: "Lithuanian Litas - LTL" },
  { value: "mop", label: "Macanese Pataca - MOP" },
  { value: "mkd", label: "Macedonian Denar - MKD" },
  { value: "mga", label: "Malagasy Ariary - MGA" },
  { value: "mwk", label: "Malawian Kwacha - MWK" },
  { value: "mvr", label: "Maldivian Rufiyaa - MVR" },
  { value: "mro", label: "Mauritanian Ouguiya - MRO" },
  { value: "mur", label: "Mauritian Rupee - MUR" },
  { value: "mdl", label: "Moldovan Leu - MDL" },
  { value: "mnt", label: "Mongolian Tögrög - MNT" },
  { value: "mad", label: "Moroccan Dirham - MAD" },
  { value: "mzn", label: "Mozambican Metical - MZN" },
  { value: "mmk", label: "Myanmar Kyat - MMK" },
  { value: "nad", label: "Namibian Dollar - NAD" },
  { value: "npr", label: "Nepalese Rupee - NPR" },
  { value: "ang", label: "Netherlands Antillean Gulden - ANG" },
  { value: "twd", label: "New Taiwan Dollar - TWD" },
  { value: "nio", label: "Nicaraguan Córdoba - NIO" },
  { value: "ngn", label: "Nigerian Naira - NGN" },
  { value: "kpw", label: "North Korean Won - KPW" },
  { value: "omr", label: "Omani Rial - OMR" },
  { value: "pkr", label: "Pakistani Rupee - PKR" },
  { value: "pab", label: "Panamanian Balboa - PAB" },
  { value: "pgk", label: "Papua New Guinean Kina - PGK" },
  { value: "pyg", label: "Paraguayan Guaraní - PYG" },
  { value: "pen", label: "Peruvian Nuevo Sol - PEN" },
  { value: "php", label: "Philippine Peso - PHP" },
  { value: "qar", label: "Qatari Riyal - QAR" },
  { value: "ron", label: "Romanian Leu - RON" },
  { value: "rub", label: "Russian Ruble - RUB" },
  { value: "rwf", label: "Rwandan Franc - RWF" },
  { value: "shp", label: "Saint Helenian Pound - SHP" },
  { value: "svc", label: "Salvadoran Colón - SVC" },
  { value: "wst", label: "Samoan Tala - WST" },
  { value: "std", label: "São Tomé and Príncipe Dobra - STD" },
  { value: "sar", label: "Saudi Riyal - SAR" },
  { value: "rsd", label: "Serbian Dinar - RSD" },
  { value: "scr", label: "Seychellois Rupee - SCR" },
  { value: "sll", label: "Sierra Leonean Leone - SLL" },
  { value: "skk", label: "Slovak Koruna - SKK" },
  { value: "sbd", label: "Solomon Islands Dollar - SBD" },
  { value: "sos", label: "Somali Shilling - SOS" },
  { value: "krw", label: "South Korean Won - KRW" },
  { value: "lkr", label: "Sri Lankan Rupee - LKR" },
  { value: "sdg", label: "Sudanese Pound - SDG" },
  { value: "srd", label: "Surinamese Dollar - SRD" },
  { value: "szl", label: "Swazi Lilangeni - SZL" },
  { value: "syp", label: "Syrian Pound - SYP" },
  { value: "tjs", label: "Tajikistani Somoni - TJS" },
  { value: "tzs", label: "Tanzanian Shilling - TZS" },
  { value: "thb", label: "Thai Baht - THB" },
  { value: "top", label: "Tongan Paʻanga - TOP" },
  { value: "ttd", label: "Trinidad and Tobago Dollar - TTD" },
  { value: "tnd", label: "Tunisian Dinar - TND" },
  { value: "try", label: "Turkish Lira - TRY" },
  { value: "tmm", label: "Turkmenistani Manat - TMM" },
  { value: "tmt", label: "Turkmenistani Manat - TMM" },
  { value: "ugx", label: "Ugandan Shilling - UGX" },
  { value: "uah", label: "Ukrainian Hryvnia - UAH" },
  { value: "aed", label: "United Arab Emirates Dirham - AED" },
  { value: "uyu", label: "Uruguayan Peso - UYU" },
  { value: "uzs", label: "Uzbekistani Som - UZS" },
  { value: "vuv", label: "Vanuatu Vatu - VUV" },
  { value: "vef", label: "Venezuelan Bolívar - VEF" },
  { value: "vnd", label: "Vietnamese Đồng - VND" },
  { value: "xof", label: "West African Cfa Franc - XOF" },
  { value: "yer", label: "Yemeni Rial - YER" },
  { value: "zmk", label: "Zambian Kwacha - ZMK" },
  { value: "zwd", label: "Zimbabwean Dollar - ZWD" },
];

export const currencyIcons = [
  { label: "usd", value: "$" },
  { label: "eur", value: "€" },
  { label: "gbp", value: "£" },
  { label: "aud", value: "$" },
  { label: "cad", value: "CAD $" },
  { label: "chf", value: "CHF" },
  { label: "czk", value: "Kč" },
  { label: "dkk", value: "kr" },
  { label: "hkd", value: "$" },
  { label: "huf", value: "Ft" },
  { label: "ils", value: "₪" },
  { label: "jpy", value: "¥" },
  { label: "mxn", value: "$" },
  { label: "nok", value: "kr" },
  { label: "nzd", value: "$" },
  { label: "pln", value: "zł" },
  { label: "sek", value: "kr" },
  { label: "sgd", value: "$" },
  { label: "afn", value: "؋" },
  { label: "all", value: "Lek" },
  { label: "dzd", value: "د.ج" },
  { label: "aoa", value: "Kz" },
  { label: "ars", value: "$" },
  { label: "amd", value: "֏" },
  { label: "awg", value: "ƒ" },
  { label: "azn", value: "₼" },
  { label: "bsd", value: "$" },
  { label: "bhd", value: ".د.ب" },
  { label: "bdt", value: "৳" },
  { label: "bbd", value: "$" },
  { label: "byr", value: "Br" },
  { label: "bzd", value: "BZ$" },
  { label: "bmd", value: "$" },
  { label: "btn", value: "Nu" },
  { label: "bob", value: "$b" },
  { label: "bam", value: "KM" },
  { label: "bwp", value: "P" },
  { label: "brl", value: "R$" },
  { label: "bnd", value: "$" },
  { label: "bgn", value: "лв" },
  { label: "bif", value: "FBu" },
  { label: "khr", value: "៛" },
  { label: "cve", value: "Esc" },
  { label: "kyd", value: "$" },
  { label: "xaf", value: "CFA" },
  { label: "xpf", value: "₣" },
  { label: "clp", value: "$" },
  { label: "cny", value: "¥" },
  { label: "cop", value: "$" },
  { label: "kmf", value: "CF" },
  { label: "cdf", value: "FC" },
  { label: "crc", value: "₡" },
  { label: "hrk", value: "kn" },
  { label: "cuc", value: "CUC" },
  { label: "cup", value: "₱" },
  { label: "djf", value: "Fdj" },
  { label: "dop", value: "RD$" },
  { label: "xcd", value: "$" },
  { label: "egp", value: "£" },
  { label: "ern", value: "Nfk" },
  { label: "eek", value: "KR" },
  { label: "etb", value: "Br" },
  { label: "fkp", value: "£" },
  { label: "fjd", value: "$" },
  { label: "gmd", value: "D" },
  { label: "gel", value: "₾" },
  { label: "ghs", value: "¢" },
  { label: "gip", value: "£" },
  { label: "gtq", value: "Q" },
  { label: "gnf", value: "FG" },
  { label: "gyd", value: "$" },
  { label: "htg", value: "G" },
  { label: "hnl", value: "L" },
  { label: "isk", value: "kr" },
  { label: "inr", value: "₹" },
  { label: "idr", value: "Rp" },
  { label: "irr", value: "﷼" },
  { label: "iqd", value: "د.ع" },
  { label: "jmd", value: "J$" },
  { label: "jod", value: "د.ا" },
  { label: "kzt", value: "лв" },
  { label: "kes", value: "KSh" },
  { label: "kwd", value: "د.ك" },
  { label: "kgs", value: "лв" },
  { label: "lak", value: "₭" },
  { label: "lbp", value: "£" },
  { label: "lsl", value: "L" },
  { label: "lrd", value: "$" },
  { label: "zar", value: "R" },
  { label: "myr", value: "RM" },
  { label: "ghc", value: "₵" },
  { label: "lyd", value: "ل.د" },
  { label: "mop", value: "MOP$" },
  { label: "mkd", value: "ден" },
  { label: "mga", value: "Ar" },
  { label: "mwk", value: "MK" },
  { label: "mvr", value: "ރ" },
  { label: "mro", value: "أ.م" },
  { label: "mur", value: "₨" },
  { label: "mdl", value: "MDL" },
  { label: "mnt", value: "₮" },
  { label: "mad", value: "Ar" },
  { label: "mzn", value: "MT" },
  { label: "mmk", value: "K" },
  { label: "nad", value: "$" },
  { label: "npr", value: "₨" },
  { label: "ang", value: "ƒ" },
  { label: "twd", value: "NT$" },
  { label: "nio", value: "C$" },
  { label: "ngn", value: "₦" },
  { label: "kpw", value: "₩" },
  { label: "omr", value: "﷼" },
  { label: "pkr", value: "₨" },
  { label: "pab", value: "B/." },
  { label: "pgk", value: "K" },
  { label: "pyg", value: "Gs" },
  { label: "pen", value: "S/." },
  { label: "php", value: "₱" },
  { label: "qar", value: "﷼" },
  { label: "ron", value: "lei" },
  { label: "rub", value: "₽" },
  { label: "rwf", value: "Fr" },
  { label: "shp", value: "£" },
  { label: "svc", value: "$" },
  { label: "wst", value: "WS$" },
  { label: "std", value: "Db" },
  { label: "sar", value: "﷼" },
  { label: "rsd", value: "Дин." },
  { label: "scr", value: "₨" },
  { label: "sll", value: "Le" },
  { label: "sbd", value: "$" },
  { label: "sos", value: "S" },
  { label: "krw", value: "₩" },
  { label: "lkr", value: "₨" },
  { label: "sdg", value: "£" },
  { label: "srd", value: "$" },
  { label: "szl", value: "L" },
  { label: "syp", value: "£" },
  { label: "tjs", value: "SM" },
  { label: "tzs", value: "v" },
  { label: "thb", value: "฿" },
  { label: "top", value: "T$" },
  { label: "ttd", value: "TT$" },
  { label: "tnd", value: "د.ت" },
  { label: "try", value: "₺" },
  { label: "tmt", value: "T" },
  { label: "ugx", value: "USh" },
  { label: "uah", value: "₴" },
  { label: "aed", value: "د.إ" },
  { label: "uyu", value: "$U" },
  { label: "uzs", value: "лв" },
  { label: "vuv", value: "Vt" },
  { label: "vef", value: "Bs" },
  { label: "vnd", value: "₫" },
  { label: "xof", value: "CFA" },
  { label: "yer", value: "﷼" },
  { label: "zmk", value: "ZK" },
  { label: "zwd", value: "Z$" },
];

export const currencyPosition = [
  { label: "Left of Amount", value: "left" },
  { label: "Right of Amount", value: "right" },
];

export const currencyFormat = [
  { label: "ISO Code (USD)", value: "iso" },
  { label: "Symbol ($)", value: "symbol" },
];

export const mileageUnit = [
  { label: "Kilometer", value: "kilometer" },
  { label: "Mile", value: "mile" },
];

export const numberFormat = [
  { label: "100,000.00", value: "comma_dot" },
  // { label: "100.000,00", value: "dot_comma" },
  { label: "100 000.00", value: "space_dot" },
  { label: "100 000,00", value: "space_comma" },
  { label: "100000.00", value: "swiss" },
  { label: "100000,00", value: "swiss_german" },
];

export const dateTimeFormat = [
  {
    label: "MMM-DD-YYYY HH:MM:SS",
    value: "MMM-DD-YYYY HH:MM:SS",
  },
  {
    label: "MMM-DD-YYYY HH:MM:SS XM",
    value: "MMM-DD-YYYY HH:MM:SS XM",
  },
  {
    label: "MMM-DD-YYYY HH:MM",
    value: "MMM-DD-YYYY HH:MM",
  },
  {
    label: "MMM-DD-YYYY HH:MM XM",
    value: "MMM-DD-YYYY HH:MM XM",
  },
  {
    label: "DD-MM-YYYY HH:MM:SS",
    value: "DD-MM-YYYY HH:MM:SS",
  },
  {
    label: "DD-MM-YYYY HH:MM:SS XM",
    value: "DD-MM-YYYY HH:MM:SS XM",
  },
  {
    label: "DD-MM-YYYY HH:MM",
    value: "DD-MM-YYYY HH:MM",
  },
  {
    label: "DD-MM-YYYY HH:MM XM",
    value: "DD-MM-YYYY HH:MM XM",
  },
  {
    label: "YYYY--MM-DD HH:MM:SS",
    value: "YYYY--MM-DD HH:MM:SS",
  },
  {
    label: "YYYY--MM-DD HH:MM:SS XM",
    value: "YYYY--MM-DD HH:MM:SS XM",
  },
  {
    label: "YYYY--MM-DD HH:MM",
    value: "YYYY--MM-DD HH:MM",
  },
  {
    label: "YYYY--MM-DD HH:MM XM",
    value: "YYYY--MM-DD HH:MM XM",
  },
];

export const timeFormat = [
  {
    label: "HH:MM:SS",
    value: "HH:MM:SS",
  },
  {
    label: "HH:MM:SS XM",
    value: "HH:MM:SS XM",
  },
  {
    label: "HH:MM",
    value: "HH:MM",
  },
  {
    label: "HH:MM XM",
    value: "HH:MM XM",
  },
];

export const dateFormat = [
  {
    label: "MMM-DD-YYYY",
    value: "MMM-DD-YYYY",
  },
  {
    label: "DD-MM-YYYY",
    value: "DD-MM-YYYY",
  },
  {
    label: "YYYY--MM-DD",
    value: "YYYY--MM-DD",
  },
  {
    label: "MM/DD/YYYY",
    value: "MM/DD/YYYY",
  },
  {
    label: "DD/MM/YYYY",
    value: "DD/MM/YYYY",
  },
  {
    label: "YYYY/MM/DD",
    value: "YYYY/MM/DD",
  },
  {
    label: "YYYY/DD/MM",
    value: "YYYY/DD/MM",
  },
];

export const timeZone = [
  {
    label: "America/New_York",
    value: "America/New_York",
  },
  {
    label: "America/Noaman",
    value: "America/Noman",
  },
  {
    label: "America/Torento",
    value: "America/Torento",
  },
  {
    label: "America/Boise",
    value: "America/Boise",
  },
  {
    label: "America/Atka",
    value: "America/Atka",
  },
  {
    label: "Asia/Aden",
    value: "Asia/Aden",
  },
];

export const invoiceDefaultTab = [
  {
    label: "Archvied",
    value: "Archvied",
  },
  {
    label: "All",
    value: "All",
  },
  {
    label: "Draft",
    value: "Draft",
  },
  {
    label: "Paid",
    value: "Paid",
  },
  {
    label: "Unpaid",
    value: "Unpaid",
  },
  {
    label: "Overdue",
    value: "Overdue",
  },
];

export const leadDefaultTab = [
  {
    label: "Archvied",
    value: "Archvied",
  },
  {
    label: "All",
    value: "All",
  },
  {
    label: "Draft",
    value: "Draft",
  },
  {
    label: "Paid",
    value: "Paid",
  },
  {
    label: "Unpaid",
    value: "Unpaid",
  },
  {
    label: "Overdue",
    value: "Overdue",
  },
];

export const estimateDefaultTab = [
  {
    label: "Archvied",
    value: "Archvied",
  },
  {
    label: "All",
    value: "All",
  },
  {
    label: "Draft",
    value: "Draft",
  },
  {
    label: "Paid",
    value: "Paid",
  },
  {
    label: "Unpaid",
    value: "Unpaid",
  },
  {
    label: "Overdue",
    value: "Overdue",
  },
];

export const oneTimeColumns = [
  {
    title: "Sr.",
    dataIndex: "sr_no",
    key: "sr_no",
  },
  {
    title: "Item",
    dataIndex: "item_name",
    key: "item_name",
  },
  {
    title: "Price",
    key: "item_price",
    dataIndex: "item_price",
  },
  {
    title: "Quantity",
    key: "item_qty",
    dataIndex: "item_qty",
  },
  {
    title: "Total Price",
    key: "total_price",
    dataIndex: "total_price",
  },
];

export const monthlyColumns = [
  {
    title: "Sr.",
    dataIndex: "sr_no",
    key: "sr_no",
  },
  {
    title: "Item",
    dataIndex: "item_name",
    key: "item_name",
  },
  {
    title: "Price",
    key: "item_price",
    dataIndex: "item_price",
  },

  {
    title: "Total Price",
    key: "total_price",
    dataIndex: "total_price",
  },
];

export const shippingModes = [
  { label: "FedEx", value: "FedEx" },
  { label: "UPS", value: "UPS" },
  { label: "USPS", value: "USPS" },
  { label: "DHL", value: "DHL" },
  { label: "Blue Dart", value: "BlueDart" },
  { label: "Ocean", value: "Ocean" },
  { label: "Personal", value: "Personal" },
  { label: "Available (On Demand)", value: "Available" },
];

export const pathOptions = [
  { path: "/dashboard", value: "dashboard", hasFilter: false },
  { path: "/opportunities", value: "opportunity", hasFilter: true },
  { path: "/contacts", value: "contacts", hasFilter: true },
  { path: "/companies/customer", value: "companies", hasFilter: true },
  { path: "/media", value: "media", hasFilter: true },
  { path: "/marketing/leads", value: "marketing", hasFilter: true },
  { path: "/proposals", value: "proposals", hasFilter: true },
  { path: "/invoices", value: "invoices", hasFilter: true },
  { path: "/payments", value: "payments", hasFilter: true },
  { path: "/supplier", value: "supplier", hasFilter: true },
  { path: "/inventory", value: "inventory", hasFilter: true },
  { path: "/purchase-order-list", value: "purchase-order", hasFilter: false },
  { path: "/shipping", value: "shipping", hasFilter: true },
  { path: "/installation", value: "installation", hasFilter: true },
  { path: "/subscription", value: "subscription", hasFilter: true },
  { path: "/porting", value: "porting", hasFilter: true },
  { path: "/tickets", value: "tickets", hasFilter: true },
  { path: "/reports", value: "reports", hasFilter: false },
  { path: "/map", value: "map", hasFilter: false },
  { path: "/event-lead/leads", value: "event-lead", hasFilter: true },
  { path: "/settings", value: "settings", hasFilter: false },
];

export const usStates = [
  { label: "ALL", value: "ALL" },
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const caStates = [
  { label: "ALL", value: "ALL" },
  { label: "Alberta", value: "AB" },
  { label: "British Columbia", value: "BC" },
  { label: "Manitoba", value: "MB" },
  { label: "New Brunswick", value: "NB" },
  { label: "Newfoundland and Labrador", value: "NL" },
  { label: "Northwest Territories", value: "NT" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Nunavut", value: "NU" },
  { label: "Ontario", value: "ON" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Quebec", value: "QC" },
  { label: "Saskatchewan", value: "SK" },
  { label: "Yukon", value: "YT" },
];

export const inStates = [
  { label: "ALL", value: "ALL" },
  { label: "Andhra Pradesh", value: "AP" },
  { label: "Arunachal Pradesh", value: "AR" },
  { label: "Assam", value: "AS" },
  { label: "Bihar", value: "BR" },
  { label: "Chhattisgarh", value: "CG" },
  { label: "Goa", value: "GA" },
  { label: "Gujarat", value: "GJ" },
  { label: "Haryana", value: "HR" },
  { label: "Himachal Pradesh", value: "HP" },
  { label: "Jharkhand", value: "JH" },
  { label: "Karnataka", value: "KA" },
  { label: "Kerala", value: "KL" },
  { label: "Madhya Pradesh", value: "MP" },
  { label: "Maharashtra", value: "MH" },
  { label: "Manipur", value: "MN" },
  { label: "Meghalaya", value: "ML" },
  { label: "Mizoram", value: "MZ" },
  { label: "Nagaland", value: "NL" },
  { label: "Odisha", value: "OR" },
  { label: "Punjab", value: "PB" },
  { label: "Rajasthan", value: "RJ" },
  { label: "Sikkim", value: "SK" },
  { label: "Tamil Nadu", value: "TN" },
  { label: "Telangana", value: "TG" },
  { label: "Tripura", value: "TR" },
  { label: "Uttar Pradesh", value: "UP" },
  { label: "Uttarakhand", value: "UK" },
  { label: "West Bengal", value: "WB" },
  { label: "Andaman and Nicobar Islands", value: "AN" },
  { label: "Chandigarh", value: "CH" },
  { label: "Dadra and Nagar Haveli and Daman and Diu", value: "DN" },
  { label: "Lakshadweep", value: "LD" },
  { label: "Delhi", value: "DL" },
  { label: "Puducherry", value: "PY" },
  { label: "Ladakh", value: "LA" },
  { label: "Jammu and Kashmir", value: "JK" },
];
